if (!customElements.get('back-to-top')) {
  customElements.define(
    'back-to-top',
    class BackToTop extends HTMLElement {
      connectedCallback() {
        this.link = this.querySelector('a');
        if (!this.link) return;
        this.onClick = this.onClick.bind(this);
        this.link.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        if (this.link) this.link.removeEventListener('click', this.onClick);
      }

      // The first tabbed Hover expand cards section, or any Hover expand cards section as a fallback.
      findTabbedCards() {
        const cards = document.querySelector('.hxc--tabbed') || document.querySelector('.hxc');
        return cards ? cards.closest('.shopify-section') || cards : null;
      }

      // Height of a sticky/fixed header, so the target is not hidden underneath it.
      stickyHeaderHeight() {
        if (this.dataset.stickyHeader !== 'true') return 0;
        const header = document.querySelector('sticky-header') || document.querySelector('.section-header');
        if (!header) return 0;
        const position = getComputedStyle(header).position;
        return position === 'sticky' || position === 'fixed' ? header.offsetHeight : 0;
      }

      onClick(event) {
        event.preventDefault();

        let top = 0;
        if (this.dataset.target === 'tabs') {
          const target = this.findTabbedCards();
          if (target) {
            const offset = (parseInt(this.dataset.offset, 10) || 0) + this.stickyHeaderHeight();
            top = target.getBoundingClientRect().top + window.scrollY - offset;
          }
        }

        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        window.scrollTo({ top: Math.max(0, top), behavior: reducedMotion ? 'auto' : 'smooth' });
      }
    }
  );
}
